import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
`;
